import { Component, OnInit } from '@angular/core';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'app-frontend-version',
  templateUrl: './frontend-version.component.html'
})
export class FrontendVersionComponent {

  constructor(
    private utilService: UtilService
  ) { }

  get version() {
    return this.utilService.getVersion();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/frontend-version/frontend-version.component.ts